module.exports = __webpack_public_path__ + "static/media/social-reddit.71edd392.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/auth/social-reddit.svg
// module id = 352
// module chunks = 0